import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import '../index.scss';

export default class BookerAccountInfo extends React.Component {
  constructor(props) {
    super(props);

    // const { business } = this.props;
    this.state = {
      clientId: '',
      userName: '',
      password: '',
      mandatoryFieldError: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onNextButtonClick = this.onNextButtonClick.bind(this);
    this.validate = this.validate.bind(this);
  }

  componentDidMount(){
    const { softwares } = this.props;
    const { zenotiData, form , LOGIN , PASSWORD} = softwares;
    console.log('LOGIN 1',form , LOGIN , PASSWORD, this.state);
    console.log('props', this.props);
    this.setState({
      ...((zenotiData.clientId || form.clientId) && {clientId: form.clientId?form.clientId:zenotiData.clientId}),
      ...((zenotiData.userName || form.userName) && {userName: form.userName?form.userName:zenotiData.userName}),
      ...((zenotiData.password || form.password) && {password: form.password?form.password:zenotiData.password})
    });
  }

  onInputChange(event) {
    this.setState({
      [event.target.name]: event.target.value,
    });
  }

  onNextButtonClick() {
    const { clientId, userName, password } = this.state;

    const data = {
      client:'CLOUD9',
      clientId,
      userName,
      password
    };
    const validationResult = this.validate(data);

    if (validationResult) {
      this.props.postZenotiAccountInfo(data);
      this.props.storeZentiData(data)
    }
  }

  validate(data) {
     if (!(data.clientId || data.userName || data.password)) {
      this.setState({
        mandatoryFieldError: true,
      });

      return false;
    }

    this.setState({
      mandatoryFieldError: false,
    });

    return true;
  }

  render() {
    const { clientId, userName, password, mandatoryFieldError } = this.state;
    const { softwares } = this.props;
    return (
      <div className="authorize-access">
        <form className="authorize-access__form">
          {mandatoryFieldError ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Fields marked in red are mandatory!
            </p>
          ) : null}
          {softwares.isBookerAccountInfoSaveFail ? (
            <p className="authorize-access__error">
              <i className="fa fa-exclamation-circle" aria-hidden="true" />
              Unable to save clientId, userName, password information
            </p>
          ) : null}
        
          <div className="authorize-access__form__row form-group">
             <p className="form-group__heading">Enter your client id *</p>
              <input
               type="text"
               name="clientId"
               className={classnames({ 'has-error': mandatoryFieldError })}
               value={clientId}
               onChange={this.onInputChange}
               autoComplete="false"
              />
             <p className="form-group__heading">Enter your user name *</p>
              <input
                type="text"
                name="userName"
                className={classnames({ 'has-error': mandatoryFieldError })}
                value={userName}
                onChange={this.onInputChange}
                autoComplete="false"
              />
             <p className="form-group__heading">Enter password *</p>
               <input
                 type="text"
                 name="password"
                 className={classnames({ 'has-error': mandatoryFieldError })}
                 value={password}
                 onChange={this.onInputChange}
                 autoComplete="false"
               />
          </div>

        </form>
        <div className="authorize-access__actions">
          <button className="btn btn--secondary btn--lg" type="button" onClick={this.props.onBackClick}>
            Previous
          </button>
          <button
            className="btn btn--primary btn--lg"
            onClick={this.onNextButtonClick}
            disabled={softwares.isSavingBookerAccountInfo}
          >
            {!softwares.isSavingBookerAccountInfo ? 'Next' : 'Saving...'}
          </button>
        </div>
      </div>
    );
  }
}

BookerAccountInfo.defaultProps = {
  postZenotiAccountInfo: () => {},
  onBackClick: () => {},
};

BookerAccountInfo.propTypes = {
  postZenotiAccountInfo: PropTypes.func,
  onBackClick: PropTypes.func,
  softwares: PropTypes.shape().isRequired,
};